export default __webpack_public_path__ + "static/media/bg.98861e43.svg";